import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { addNotification, removeNotification, clearNotifications } from '../store/slices/uiSlice';

export function useNotifications() {
  const dispatch = useDispatch();
  const notifications = useSelector((state: RootState) => state.ui.notifications);

  const notify = {
    success: (title: string, message?: string, options?: { autoClose?: boolean; duration?: number }) => {
      dispatch(addNotification({
        type: 'success',
        title,
        message,
        autoClose: options?.autoClose ?? true,
        duration: options?.duration ?? 5000, // 5 seconds for success
        ...options,
      }));
    },
    
    error: (title: string, message?: string, options?: { autoClose?: boolean; duration?: number }) => {
      dispatch(addNotification({
        type: 'error',
        title,
        message,
        autoClose: options?.autoClose ?? true, // Errors now auto-close by default
        duration: options?.duration ?? 10000, // 10 seconds for errors
        ...options,
      }));
    },
    
    warning: (title: string, message?: string, options?: { autoClose?: boolean; duration?: number }) => {
      dispatch(addNotification({
        type: 'warning',
        title,
        message,
        autoClose: options?.autoClose ?? true,
        duration: options?.duration ?? 8000, // 8 seconds for warnings
        ...options,
      }));
    },
    
    info: (title: string, message?: string, options?: { autoClose?: boolean; duration?: number }) => {
      dispatch(addNotification({
        type: 'info',
        title,
        message,
        autoClose: options?.autoClose ?? true,
        duration: options?.duration ?? 6000, // 6 seconds for info
        ...options,
      }));
    },
  };

  const dismiss = (id: string) => {
    dispatch(removeNotification(id));
  };

  const clear = () => {
    dispatch(clearNotifications());
  };

  return {
    notifications,
    notify,
    dismiss,
    clear,
  };
}